import { placeholdersEntries } from '@cx-modules/offers-placeholder-translations';

export const useMapRequiredNamespaces = (placeholders: string | undefined) => {
  if (!placeholders) return;
  const entries = placeholdersEntries(placeholders);
  const keys = Object.keys(entries);

  if (!keys.length) {
    return placeholders;
  }

  return [
    ...new Set(
      keys
        .map(key => {
          switch (key) {
            case 'SUBEVENT':
            case 'EVENT': {
              return entries.SPORT?.toLowerCase();
            }
            case 'SPORT':
            case 'MARKET': {
              return 'label';
            }

            default: {
              return undefined;
            }
          }
        })
        .filter(item => item !== undefined),
    ),
  ];
};
